/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { useI18n } from 'nordic/i18n';
import { Button } from '@andes/button';
import { ModalBase } from './modal';

const MS_KEEP_ACTIONS_DISABLED = 2000; // wait till enable buttons
const LS_DISMISS_KEY = '__dx-modal-coexistence-dismiss';

function hasBeenDismissedOnStorage(sid = '') {
  try {
    return window.localStorage.getItem(`${LS_DISMISS_KEY}_${sid}`);
  } catch {
    return true;
  }
}

function dismissOnStorage(sid = '') {
  try {
    window.localStorage.setItem(`${LS_DISMISS_KEY}_${sid}`, 1);
  } catch {
    console.trace('Could not access local storage');
  }
}

// ------------------------------------------------------------------------

export const ModalAPIOrder = ({ lang, brand, coexistenceEnabled }) => {
  if (!coexistenceEnabled) {
    return null;
  }

  const { i18n } = useI18n();
  const [open, setOpen] = useState(false);
  const [isFromOrders, setIsFromOrders] = useState(false);
  const [disabled, setDisabled] = useState(true);

  // keep the dismiss state on local storage by modal intention
  // const modalStorageId = isFromOrders ? 'orders' : 'payments';
  // if we differ the id, the modal will be kept for orders or
  // payments differentlfy. if we keep the same, when you dismiss
  // the orders modal, the payments wont be shown and vice-versa
  const modalStorageId = 'all';
  const dismiss = () => dismissOnStorage(modalStorageId);

  const mustActivateModal = (currentPathname) => {
    if (typeof currentPathname !== 'string' || !currentPathname?.trim()) {
      return false;
    }

    if (currentPathname.match(/\/checkout-api-v2\//) || currentPathname.match(/\/checkout-api-orders\//)) {
      setIsFromOrders(true);
      return true;
    }

    if (currentPathname.match(/\/checkout-api\//) || currentPathname.match(/\/checkout-api-legacy\//)) {
      setIsFromOrders(false);
      return true;
    }

    return null;
  };

  useEffect(() => {
    if (typeof window !== typeof undefined) {
      const { pathname } = window.location;
      setOpen(mustActivateModal(pathname));
    }

    if (mustActivateModal) {
      setDisabled(true);
      setTimeout(() => setDisabled(false), MS_KEEP_ACTIONS_DISABLED);
    }
  }, []);


  if (typeof window === typeof undefined || hasBeenDismissedOnStorage(modalStorageId)) {
    return null;
  }

  if (mustActivateModal) {
    return (
      <ModalBase
        open={open}
        brandColor={(brand === 'yellowblue-light' ? '#FFE600' : '#5AD2FF')}
        srLabel={i18n.gettext('¡Explora la nueva API Orders! Una forma eficiente de integrar Checkout API')}
        title={i18n.gettext('¡Explora la nueva API Orders! Una forma eficiente de integrar Checkout API')}
      >
        {isFromOrders ? (
          <form action={`/developers/${lang}/docs/checkout-api/landing#from=coexistence_gotopayments_click`}>
            <Button
              disabled={disabled}
              hierarchy="transparent"
              type="submit"
              onClick={() => dismiss()}
            >
              {i18n.gettext('Ir a API Payments')}
            </Button>
          </form>
        ) : (
          <Button
            disabled={disabled}
            hierarchy="transparent"
            onClick={() => {
              dismiss();
              setOpen(false);

              try {
                // we do this ghost refresh the page and send a new fragment to melidata
                // without the needing to redo the catalog or redo a complete page refresh
                const $iframe = Object.assign(document.createElement('iframe'), {
                  src: `${window.location.href}#from=orders_keep_me_here_clicked`,
                  style: 'display: none',
                });

                document.body.append($iframe);
              } catch (error) {
                console.error(error);
              }
            }}
          >
            {i18n.gettext('Permanecer aquí')}
          </Button>
        )}

        {isFromOrders ? (
          <Button
            disabled={disabled}
            onClick={() => {
              dismiss();
              setOpen(false);
            }}
          >
            {i18n.gettext('Explorar API Orders')}
          </Button>
        ) : (
          <form action={`/developers/${lang}/docs/checkout-api-v2/integration-model#from=coexistence_exploreorders_click`}>
            <Button disabled={disabled} type="submit" onClick={() => dismiss()}>
              {i18n.gettext('Explorar API Orders')}
            </Button>
          </form>
        )}
      </ModalBase>
    );
  }

  return null;
};
